import { getAPI, postAPI, putAPI } from "../..";
import config from "../../../utils/config";
import {
  CREATE_EVENT_URL,
  CREATE_MICE_URL,
  EVENT_DETAILS_URL,
  EVENT_LIST_URL,
  GET_IMAGES_URL,
  REVIEW_DETAILS,
  NEW_EVENT_LIST_URL,
  UPLOAD_EVENT_FILE,
  VENDOR_DOC_URL,
  EVENT_CHECK_URL,
  CHECK_ATTENDEES_UPLOAD,
} from "../../url";

export const eventListingAPI = async (
  type,
  workflow_id,
  page_no = 1,
  per_page = 2
) => {
  let response = await getAPI(
    config.workflowUrl +
      EVENT_LIST_URL +
      workflow_id +
      "?workflow_type=" +
      type +
      "&page=1&per_page=100000"
  );
  return response;
};

export const uploadVendorDocs = async (
  workflow_id,
  step_id,
  action_name,
  body
) => {
  let response = await putAPI(
    config.workflowUrl +
      VENDOR_DOC_URL +
      workflow_id +
      "/step/" +
      step_id +
      "?action_name=" +
      action_name,
    body
  );
  return response;
};

export const newEventListingAPI = async (
  type,
  page_no = 1,
  per_page = 2,
  status,
  email,
  list_type
) => {
  let url = `?type=${type}&page=${page_no}&per_page=${per_page}&event_status=${status}&list_type=${list_type}`;

  if (email !== "")
    url = `?email=${email}&type=${type}&page=${page_no}&per_page=${per_page}&event_status=${status}&list_type=${list_type}`;

  let response = await getAPI(config.quicklinkUrl + NEW_EVENT_LIST_URL + url);
  return response;
};

export const createEventAPI = async (workflow_id, step_id, body) => {
  let response = await postAPI(
    config.workflowUrl + CREATE_EVENT_URL + workflow_id + "/step/" + step_id,
    body
  );
  return response;
};

export const createMiceAPI = async (workflow_id, step_id, body) => {
  let response = await postAPI(
    config.workflowUrl + CREATE_MICE_URL + workflow_id + "/step/" + step_id,
    body
  );
  return response;
};

export const eventDetailsAPI = async (event_id) => {
  let response = await getAPI(
    config.workflowUrl + EVENT_DETAILS_URL + event_id
  );
  return response;
};

export const getAllImagesAPI = async (workflow_id, event_id) => {
  let response = await getAPI(
    config.workflowUrl +
      GET_IMAGES_URL +
      workflow_id +
      "?workflow_type=image&event_id=" +
      event_id +
      "&page=1&per_page=100000"
  );
  return response;
};

export const getAllReviewsAPI = async (workflow_id, event_id) => {
  let response = await getAPI(config.quicklinkUrl + REVIEW_DETAILS + event_id);
  return response;
};

export const uploadExtraEventDocs = async (event_id, body) => {
  let response = await putAPI(
    config.quicklinkUrl + UPLOAD_EVENT_FILE + event_id,
    body
  );
  return response;
};

export const addEventPlanAPI = async (workflow_id, step_id, body, day) => {
  let response = await putAPI(
    config.workflowUrl +
      CREATE_EVENT_URL +
      workflow_id +
      "/step/" +
      step_id +
      "?day=" +
      day +
      "&action_name=ADD_EVENT_PLAN",
    body
  );
  return response;
};

export const editEventPlanAPI = async (workflow_id, step_id, body, day) => {
  let response = await putAPI(
    config.workflowUrl +
      CREATE_EVENT_URL +
      workflow_id +
      "/step/" +
      step_id +
      "?day=" +
      day +
      "&action_name=EDIT_EVENT_PLAN",
    body
  );
  return response;
};

export const addBoardingPassAPI = async (workflow_id, step_id, body) => {
  let response = await putAPI(
    config.workflowUrl +
      CREATE_EVENT_URL +
      workflow_id +
      "/step/" +
      step_id +
      "?action_name=ADD_BOARDING_PASS",
    body
  );
  return response;
};

export const checkEventNameAPI = async (event_name) => {
  let response = await getAPI(
    config.quicklinkUrl + EVENT_CHECK_URL + event_name
  );
  return response;
};

export const checkValidAttendeesUpload = async (body) => {
  let response = await postAPI(
    config.quicklinkUrl + CHECK_ATTENDEES_UPLOAD,
    body
  );
  return response;
};
